import { getAppInstance } from '@/utils/api/app';
import type { RawAxiosRequestHeaders } from 'axios';
import { getOperation } from '@/utils/getOperation';

export const useFetcher =
  <TData, TVariables>(query: string) =>
  async (variables?: TVariables) => {
    const operation = getOperation(query);

    const headers: RawAxiosRequestHeaders = {
      'Content-Type': 'application/json',
      'x-operation-name': operation,
    };

    const { data } = await getAppInstance().post<{ data: TData }>(
      '/savings-easy-access-graphql',
      {
        operationName: operation,
        variables,
        query,
      },
      { headers },
    );

    return data.data;
  };
